import { http, HttpResponse } from 'msw';

import { AuthLoginRequest } from 'shared/openapi/models/auth-login-request';

export default http.post<never, AuthLoginRequest>(
  '/public/api/WEB/login',
  async ({ request }) => {
    const json = await request.json();

    if (json.email === 'a' && json.password === 'a') {
      console.log('OK');
    }

    return HttpResponse.json(true);
  }
);
